// Section: References Component
import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const References = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const projects = [
    {
      title: "Kurumsal Tanıtım Filmi",
      description: "Büyük ölçekli bir tekstil firması için kurumsal kimlik ve tanıtım filmi projesi.",
      category: "Video Prodüksiyon"
    },
    {
      title: "Sosyal Medya Kampanyası",
      description: "Yerel bir restoran zinciri için sosyal medya yönetimi ve içerik stratejisi.",
      category: "Sosyal Medya"
    },
    {
      title: "Logo ve Kurumsal Kimlik",
      description: "Yeni kurulan bir teknoloji şirketi için logo tasarımı ve kurumsal kimlik çalışması.",
      category: "Grafik Tasarım"
    },
    {
      title: "Drone Çekimi Projesi",
      description: "İnşaat firması için proje tanıtımı amacıyla profesyonel drone çekimi.",
      category: "Drone Çekimi"
    },
    {
      title: "E-ticaret Fotoğraf Çekimi",
      description: "Online mağaza için ürün fotoğraf çekimi ve görsel içerik üretimi.",
      category: "Fotoğraf"
    },
    {
      title: "Açık Hava Reklam Tasarımı",
      description: "Şehir merkezinde yer alan büyük billboard tasarımı ve uygulaması.",
      category: "Reklam Tasarımı"
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };

  return (
    <section id="referanslar" className="references-section">
      <div className="references-container">
        <motion.div
          ref={ref}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          variants={containerVariants}
          className="references-header"
        >
          <motion.h2 
            variants={itemVariants}
            className="references-title"
          >
            <span className="references-title-light">Tamamladığımız</span>
            <br />
            <span className="references-title-gradient">Projeler</span>
          </motion.h2>
          <motion.p 
            variants={itemVariants}
            className="references-description"
          >
            Başarıyla tamamladığımız projelerden örnekler ve müşteri memnuniyeti odaklı çalışma anlayışımız.
          </motion.p>
        </motion.div>

        <motion.div
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          variants={containerVariants}
          className="references-grid"
        >
          {projects.map((project, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              whileHover={{ 
                scale: 1.02, 
                transition: { duration: 0.2 }
              }}
              className="reference-card"
            >
              {/* Placeholder Image */}
              <div className="reference-image">
                <div className="reference-image-placeholder">
                  <div className="reference-image-icon">📷</div>
                  <p className="reference-image-text">Proje Görseli</p>
                </div>
              </div>

              {/* Overlay */}
              <div className="reference-overlay">
                <div className="reference-overlay-content">
                  <span className="reference-category-badge">{project.category}</span>
                  <h3 className="reference-overlay-title">{project.title}</h3>
                  <p className="reference-overlay-description">{project.description}</p>
                </div>
              </div>

              {/* Default Content */}
              <div className="reference-content">
                <span className="reference-category">{project.category}</span>
                <h3 className="reference-card-title">{project.title}</h3>
                <p className="reference-card-description">{project.description}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* Background Image Placeholder Comment */}
        {/* 
          Görsel prompt: "behind the scenes media agency shoot, camera lights, creative team working, dark cinematic lighting, 8k"
          Bu görsel referanslar bölümünün arka planında kullanılacak, çalışma ortamını gösteren sinematik bir görsel
        */}
      </div>
    </section>
  );
};

export default References;